/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestYearnVaultV2 extends Contract<ITestYearnVaultV2> {
  deposit: Send<(_depositAmount: BigNumberish, _recipient: AddressLike) => BigNumber, ITestYearnVaultV2>
  'deposit(uint256,address)': Send<(_depositAmount: BigNumberish, _recipient: AddressLike) => BigNumber, ITestYearnVaultV2>
  pricePerShare: Call<() => BigNumber, ITestYearnVaultV2>
  'pricePerShare()': Call<() => BigNumber, ITestYearnVaultV2>
  token: Call<() => string, ITestYearnVaultV2>
  'token()': Call<() => string, ITestYearnVaultV2>
  withdraw: Send<(_maxShares: BigNumberish, _recipient: AddressLike, _maxLoss: BigNumberish) => BigNumber, ITestYearnVaultV2>
  'withdraw(uint256,address,uint256)': Send<(_maxShares: BigNumberish, _recipient: AddressLike, _maxLoss: BigNumberish) => BigNumber, ITestYearnVaultV2>
}

let ITestYearnVaultV2Bytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestYearnVaultV2Bytecode = '0x';
}

// prettier-ignore
export const ITestYearnVaultV2 = contract<ITestYearnVaultV2>(ITestYearnVaultV2Bytecode)`
  function deposit(uint256 _depositAmount, address _recipient) returns (uint256 amount_)
  function pricePerShare() view returns (uint256 price_)
  function token() view returns (address asset_)
  function withdraw(uint256 _maxShares, address _recipient, uint256 _maxLoss) returns (uint256 amount_)
`;